import { Button } from '@crazyegginc/hatch';

import { useAuthContext, usePermissions, useMetric, useManageSubscriptionPath } from '/src/hooks';
import { Paywall } from '/src/components/Paywall';
import { FEATURES } from '/src/features/_global/constants';

import RecordingsPNG from '@crazyegginc/hatch/dist/images/illustration-recordings-1.png';
import RecordingsWebP from '@crazyegginc/hatch/dist/images/illustration-recordings-1.webp';
import { ReactComponent as TickIcon } from '@crazyegginc/hatch/dist/images/icon-tick-circle-filled.svg';
import { ReactComponent as ArrowIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-expand.svg';
import { AppLink } from '/src/features/_global/components/AppLink';

export function RecordingsUpgradePaywall({ mini }) {
  const { currentAccount } = useAuthContext();
  const trackMetric = useMetric();
  const subscriptionPath = useManageSubscriptionPath();

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;
  const isStripeUser = Boolean(currentAccount?.useStripe);

  return (
    <Paywall>
      <Paywall.Image
        webp={RecordingsWebP}
        fallback={RecordingsPNG}
        width={mini ? '80px' : '285px'}
        className={mini ? '!mb-3 !mt-2' : ''}
      />
      <Paywall.Title mini={mini}>See clearly with Recordings</Paywall.Title>

      <Paywall.Body>
        Watch recordings of actual visitors using your website to see how they journey through your site, what makes
        them tick (or frustrated) and why!
        {mini ? null : (
          <div className="mt-6 flex justify-center">
            <div className="space-y-2">
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                Find out how long visitors stay on your site and where they struggle.
              </div>
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                Filter your recordings by visitors or behaviours.
              </div>
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                See where there are errors or visitor frustrations and how to fix them.
              </div>
            </div>
          </div>
        )}
        {!canManageBilling ? (
          <p className="mt-5">
            To get access to this feature, contact your Account Owner &#40;{currentAccount.ownerEmail}&#41; to upgrade
            the plan.
          </p>
        ) : null}
      </Paywall.Body>

      {canManageBilling ? (
        <Button
          component={AppLink}
          to={subscriptionPath}
          onMouseDown={() => trackMetric('upgrade_cta_click', 'recordings_upsell_paywall')}
          className="mb-5"
          target={isStripeUser ? '_blank' : '_self'}
          rel={isStripeUser ? 'noopener noreferrer' : undefined}
        >
          Get Recordings
          <ArrowIcon className="ml-2.5 h-2.5 w-2.5 rotate-90 fill-current" />
        </Button>
      ) : (
        <Button component="a" href={`mailto:${currentAccount.ownerEmail}`} className="mb-5">
          Contact account owner
        </Button>
      )}
    </Paywall>
  );
}
